export const APPEARANCES = {
  defaultAccent: 'default-accent',
  defaultCta: 'default-cta',
  accent: 'accent',
  cta: 'cta',
};

export const LAYOUTS = {
  default: 'default',
  mobile: 'mobile',
};
